// File d'attente PTT hors réseau: les clips vocaux sont conservés en IndexedDB
// puis envoyés automatiquement au retour du réseau (zones rurales).
import api from "@/lib/api";

const DB_NAME = "innova-ptt";
const STORE = "outbox";

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) {
        req.result.createObjectStore(STORE, { keyPath: "id", autoIncrement: true });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const out = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(out?.result ?? out);
    t.onerror = () => reject(t.error);
  });
}

export const pttQueueAdd = (item) => tx("readwrite", (s) => s.add({ ...item, at: Date.now() }));
export const pttQueueAll = () => tx("readonly", (s) => s.getAll());
const pttQueueDel = (id) => tx("readwrite", (s) => s.delete(id));

export async function pttQueueSize() {
  try { return (await pttQueueAll()).length; } catch { return 0; }
}

function formOf(item) {
  const fd = new FormData();
  fd.append("file", item.blob, `ptt.${item.ext || "webm"}`);
  fd.append("duration_sec", String(item.duration_sec || 0));
  fd.append("channel", item.channel || "driver");
  if (item.driver_id) fd.append("driver_id", item.driver_id);
  return fd;
}

/** Envoie le clip; en cas de coupure réseau il est mis en file d'attente. */
export async function sendOrQueue(item) {
  if (navigator.onLine) {
    try {
      const { data } = await api.post("/ptt/send", formOf(item));
      return { sent: true, data };
    } catch (e) {
      const retryable = !e.response || e.response.status >= 500;
      if (!retryable) throw e;
    }
  }
  await pttQueueAdd(item);
  return { sent: false, queued: true };
}

export async function pttFlush() {
  if (!navigator.onLine) return 0;
  let items = [];
  try { items = await pttQueueAll(); } catch { return 0; }
  let sent = 0;
  for (const item of items) {
    try {
      await api.post("/ptt/send", formOf(item));
      await pttQueueDel(item.id);
      sent += 1;
    } catch (e) {
      if (!e.response) break;                 // toujours hors réseau
      if (e.response.status < 500) { await pttQueueDel(item.id); continue; }
      const attempts = (item.attempts || 0) + 1;
      if (attempts >= 10) await pttQueueDel(item.id);     // erreur serveur persistante
      else await tx("readwrite", (s) => s.put({ ...item, attempts }));
    }
  }
  return sent;
}
